export var FetchTaskStatusType;
(function (FetchTaskStatusType) {
    FetchTaskStatusType["PROCESSING"] = "processing";
    FetchTaskStatusType["ERROR"] = "error";
    FetchTaskStatusType["FINISH"] = "finish";
})(FetchTaskStatusType || (FetchTaskStatusType = {}));
//# sourceMappingURL=FetchTaskStatusType.js.map